import React from 'react';
import {isFormValid, validated} from 'react-custom-validation';
import PropTypes from 'prop-types';
import update from "immutability-helper";

import { isEmail, isRequired } from '../../util/validations';
import { handleTextChange } from '../../util/handle-changes';

import ActivityIndicator from '../../_components/FormComponents/ActivityIndicator';
import Button from '../../_components/FormComponents/Button';
import Form from '../../_components/FormComponents/Form';
import FormValidationMessage from '../../_components/FormComponents/FormValidationMessage';
import FormRow from '../../_components/FormComponents/FormRow';

import Textbox from '../../_components/FormComponents/Textbox';
import {Link} from "react-router-dom";

class LoginForm extends React.Component {
    static propTypes = {
        credentials: PropTypes.object.isRequired,
        error: PropTypes.object,
        isLoggingIn: PropTypes.bool.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        setCredentials: PropTypes.func.isRequired,
    };

    handleChange = (name, value) => {
        let newCredentialsObj = update(this.props.credentials, {});
        newCredentialsObj[name] = value;
        this.props.setCredentials(newCredentialsObj);
    };

    render() {
        let { credentials, error, isLoggingIn, handleSubmit, $field, $validation } = this.props;

        return (
            <Form className="login-form auth-page__form">


                <FormRow>
                    <Textbox
                        id="txtEmailAddress"
                        label="Email"
                        labelHidden
                        name="email"
                        placeholder="Email (Required)"
                        required
                        type="email"
                        validation={$validation.email}
                        value={credentials.email || ''}
                        {...$field('email', (event) => handleTextChange(this.handleChange, event))}
                    />
                </FormRow>

                <FormRow>
                    <Textbox
                        id="txtPassword"
                        label="Password"
                        labelHidden
                        name="password"
                        placeholder="Password (Required)"
                        required
                        supportLink={{
                            text: 'Forgot your password?',
                            route: {
                            pathname: '/forgot',
                            state: { credentials }
                            }
                        }}
                        type="password"
                        validation={$validation.password}
                        value={credentials.password || ''}
                        {...$field('password', (event) => handleTextChange(this.handleChange, event))}
                    />
                </FormRow>

                {error && Object.keys(error).length > 0 ? (
                    <FormRow className="error-message">
                        <FormValidationMessage>
                            {error.friendlyMessage || error.message}
                        </FormValidationMessage>
                    </FormRow>
                ) : null}

                <div className="auth-page__form__footer">
                    <p className="auth-page__help-text">
                        No Account? <Link to="/signup">Sign Up</Link>
                    </p>
                    <FormRow className="c-form__button-wrapper">
                        <Button className='c-button--block'
                                disabled={isFormValid($validation) !== true || isLoggingIn === true}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.$submit(() => handleSubmit(true), () => handleSubmit(false));
                                }}
                                type="submit">
                            Log In
                            {isLoggingIn === true ? <ActivityIndicator color="#ffffff" /> : null}
                        </Button>
                    </FormRow>
                </div>
            </Form>
        )
    }
}

function loginFormValidationConfig(props) {
    const { email, password } = props.credentials;

    return {
        fields: ['email', 'password'],
        validations: {
            email: [
                [isRequired, email],
                [isEmail, email]
            ],
            password: [
                [isRequired, password]
            ]
        }
    }
}

export default LoginForm = validated(loginFormValidationConfig)(LoginForm);



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/LoginForm.js